<ss-dynamic-form [colCount]="1" [applyValidation]="isSelectedObs | async" [controls]="controlsObs | async"></ss-dynamic-form>
<div class="flex-row">

    <p *ngIf="validationMessageObs | async" class="error-text">{{validationMessageObs | async}}</p>
    
</div>